import { ApiResponse } from "types/api";
import { WithDrawalFormSettingType } from "types/withdraw";

import {
  WithDrawalFormSettingTypeResponse,
  WithdrawalSubMissionForm,
} from "./type";

const mockWithdrawData: WithDrawalFormSettingType = {
  player_bank: [
    {
      player_bank_id: "1",
      bank_id: "1",
      bank_name: "Ziraat Bankası",
      bank_account_name: "TK88 MEMBER",
      bank_account_no: "998877665544",
      bank_account_address: "Istanbul",
      web_image_on: "",
      mobile_image_on: "",
    },
  ],
  currencies: [
    {
      currency_id: "1",
      currency_name: "TRY",
      currency_code: "TRY",
      currency_symbol: "₺",
      t_currency_rate: 1,
      d_currency_rate: 1,
      w_currency_rate: 1,
      t_free: "0",
      d_fee: "0",
      w_fee: "0",
      is_default: "1",
      active: "1",
    },
    {
      currency_id: "2",
      currency_name: "USD",
      currency_code: "USD",
      currency_symbol: "$",
      t_currency_rate: 1,
      d_currency_rate: 1,
      w_currency_rate: 1,
      t_free: "0",
      d_fee: "0",
      w_fee: "0",
      is_default: "0",
      active: "1",
    },
  ],
  setting: {
    daily_withdrawal_times: 10,
    daily_withdrawal_limit: 1000000,
    min_withdrawal: 100,
    max_withdrawal: 100000,
  },
  turnover: {
    target: 0,
    current: 1000,
  },
};

export const withdrawApi = {
  getWithdrawalForm: async (_username: string) => {
    return {
      data: {
        status: 0,
        msg: "Success",
        data: mockWithdrawData,
      } as WithDrawalFormSettingTypeResponse,
    };
  },
  withdrawalSubmission: async (
    _username: string,
    _payload: WithdrawalSubMissionForm
  ) => {
    return {
      data: {
        status: 0,
        msg: "Withdrawal request submitted successfully",
      } as ApiResponse,
    };
  },
};
